import { getTagManager } from '../api/tagManager';
import { getFileByChecksums } from '../digitalVault';
import { getPersonsByFile } from '../tagManager';
import { parseUserResponse } from '../utils';
export const getFilesByPerson = async ({ personId, count, page, }, logger) => {
    const urlParams = new URLSearchParams();
    count && urlParams.append('count', count.toString());
    page && urlParams.append('page', page);
    const fileListResponse = await getTagManager(`person/${personId}/file?${urlParams.toString()}`, {}, logger);
    const checksumAndRepoArray = fileListResponse?.fileLists[0]?.files.map((item) => {
        const repoNameArray = item.repositoryReferences.map((repo) => {
            return {
                $: [repo],
            };
        });
        return {
            '@checksum': item.fileChecksum,
            repositoryName: repoNameArray,
        };
    });
    const { files } = await getFileByChecksums({
        checksumAndRepositoryNames: checksumAndRepoArray,
    });
    const { persons } = await getPersonsByFile({
        fileChecksum: files.file[0].checksum.$,
    }, logger);
    const person = persons.filter((item, index) => item.id === personId)[0];
    return parseUserResponse(fileListResponse.nextPage, files, () => getFilesByPerson({ personId, page: fileListResponse.nextPage }, logger), person);
};
